import { FdrGrid } from '../components/FdrGrid.tsx';

/** The fixture-difficulty grid's own route (T-048) — previously stacked
 * above the squad desk on every visit; now it only renders here. Public
 * since T-049: this component doesn't know or care whether the visitor is
 * signed in — `App.tsx` decides what surrounds it (the full `AppShell` or
 * the signed-out `PublicFixturesShell`), but the grid itself is the same
 * component either way. */
export function FixturesRoute() {
  return <FdrGrid />;
}
